import { render, staticRenderFns } from "./CommentComposer.vue?vue&type=template&id=03af3adc"
import script from "./CommentComposer.vue?vue&type=script&lang=js"
export * from "./CommentComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports